import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/features/marketing/content/content-page";
import { body } from "@/features/marketing/content/pages/guide-rsvp-wording";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/guides/wedding-rsvp-wording")({
  head: SEO["/guides/wedding-rsvp-wording"],
  component: () => <ContentPage path="/guides/wedding-rsvp-wording" body={body} />,
});
